// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `a{outline:none;border:0}`, "",{"version":3,"sources":["webpack://./overrides/app/components/mega-nav-links/MegaLink.scss"],"names":[],"mappings":"AAAA,EACE,YAAA,CACA,QAAA","sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
